/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserDtoFromJSON, UserDtoToJSON, } from './UserDto';
/**
 * Check if a given object implements the ProjectAllocationInfoDto interface.
 */
export function instanceOfProjectAllocationInfoDto(value) {
    return true;
}
export function ProjectAllocationInfoDtoFromJSON(json) {
    return ProjectAllocationInfoDtoFromJSONTyped(json, false);
}
export function ProjectAllocationInfoDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'projectName': json['projectName'] == null ? undefined : json['projectName'],
        'intranetId': json['intranetId'] == null ? undefined : json['intranetId'],
        'projectLeaderName': json['projectLeaderName'] == null ? undefined : json['projectLeaderName'],
        'projectLeaderId': json['projectLeaderId'] == null ? undefined : json['projectLeaderId'],
        'delegatiPl': json['delegatiPl'] == null ? undefined : (json['delegatiPl'].map(UserDtoFromJSON)),
        'allocationDays': json['allocationDays'] == null ? undefined : json['allocationDays'],
        'isConsolidated': json['isConsolidated'] == null ? undefined : json['isConsolidated'],
    };
}
export function ProjectAllocationInfoDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'projectId': value['projectId'],
        'projectName': value['projectName'],
        'intranetId': value['intranetId'],
        'projectLeaderName': value['projectLeaderName'],
        'projectLeaderId': value['projectLeaderId'],
        'delegatiPl': value['delegatiPl'] == null ? undefined : (value['delegatiPl'].map(UserDtoToJSON)),
        'allocationDays': value['allocationDays'],
        'isConsolidated': value['isConsolidated'],
    };
}
